import { render, staticRenderFns } from "./PracticeDetails.vue?vue&type=template&id=26535943&scoped=true"
import script from "./PracticeDetails.vue?vue&type=script&lang=js"
export * from "./PracticeDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26535943",
  null
  
)

export default component.exports